import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import { messaging } from "../../firebase/firebaseConfig";
import {
  addNotification,
  syncBackgroundNotifications,
  BACKGROUND_MESSAGE_TYPE,
} from "../../firebase/notificationStore";

// Foreground — the browser doesn't auto-show a system notification for
// messages received while the tab is open/focused, so we surface it as a
// toast ourselves, and also save it so the header's bell icon can list it.
// Background/closed-tab messages are shown by public/firebase-messaging-sw.js,
// which queues them for us — we pull that queue into the bell on mount, when
// the service worker pings us, and whenever the tab becomes visible again.
const PushNotificationListener = () => {
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const title = payload.notification?.title;
      const body = payload.notification?.body;
      toast.info(title ? `${title}${body ? ` — ${body}` : ""}` : body || "New notification");
      addNotification(payload);
    });

    syncBackgroundNotifications();

    const handleServiceWorkerMessage = (event) => {
      if (event.data?.type === BACKGROUND_MESSAGE_TYPE) syncBackgroundNotifications();
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") syncBackgroundNotifications();
    };

    navigator.serviceWorker?.addEventListener("message", handleServiceWorkerMessage);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      unsubscribe();
      navigator.serviceWorker?.removeEventListener("message", handleServiceWorkerMessage);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null;
};

export default PushNotificationListener;
